// extracted by mini-css-extract-plugin
module.exports = {"markdown":"ReviewAndJoin_markdown__2nEO6"};